import classNames from 'classnames';
import React from 'react';

import { ImageBlock } from './ImageBlock';

export interface ImageData {
  title?: string;
  src: string;
}

export interface Props {
  images: ImageData[];
  color?: 'white' | 'black';
  bgClassName?: string;
  margin?: boolean;
}

export const ImageBlocks = ({ images, color, bgClassName, margin = true }: Props) => {
  return (
    <div className={classNames(margin && 'md:mx-32', 'flex justify-around gap-y-5 flex-wrap md:flex-row flex-col')}>
      {images.map((image, index) => (
        <ImageBlock key={index} title={image.title} src={image.src} color={color} bgClassName={bgClassName} />
      ))}
    </div>
  );
};
